'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M0 96l0 384 512 0 0-384-178.7 0c30.7-30.7 52-52 64-64L352-13.3c-6.6 6.6-38.6 38.6-96 96-57.4-57.4-89.4-89.4-96-96L114.7 32c12 12 33.3 33.3 64 64L0 96zm64 64c106.7 0 213.3 0 320 0l0 256-320 0 0-256zm408 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M64 160l320 0 0 256-320 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;